import { API } from "aws-amplify";
import { ICompareVectorsResult } from "types";

const apiName = "careerminder";

export const getEmbedding = async (text: string): Promise<string> => {
    try {
        const response = await API.post(apiName, "/ai/embedding", { body: text });
        return JSON.stringify(response);
    } catch (err) {
        console.log("err", err);
        return JSON.stringify("Could not retreive embedding");
    }
};

export const saveEmbedding = async (itemId: string, text: string): Promise<string> => {
    const body = {
        itemId,
        text,
    };
    try {
        const response = await API.post(apiName, "/ai/saveembedding", { body });
        return response;
    } catch (err) {
        console.log("err", err);
        return "Error";
    }
};

export const compareVectors = async (itemId: string, comparisons: string[]): Promise<ICompareVectorsResult|Error> => {
    if (!comparisons || comparisons.length === 0) {
        return new Error("Comparisons array is empty");
    }

    const body = {
        sourceItemId: itemId,
        comparisons: comparisons,
    };
    try {
        const response = await API.post(apiName, "/ai/comparevector", { body });
        console.log("compareVectors response :>> ", response);
        return response;
    } catch (err) {
        console.log("err", err);
        return err as Error;
    }
};

export const uploadResume = async (file: File): Promise<string> => {
    if (!file) return JSON.stringify("There is no file");

    try {
        console.log("trying upload");
        const fileContent = await file.arrayBuffer();
        // Convert ArrayBuffer to Base64 string
        const base64 = btoa(
            new Uint8Array(fileContent).reduce((data, byte) => data + String.fromCharCode(byte), ""),
        );

        const response = await API.post(apiName, "/ai/resumeupload", {
            body: {
                fileContent: base64,
                fileName: file.name,
                fileType: file.type,
                fileSize: file.size,
            },
            headers: {
                "Content-Type": "application/json",
            },
        });
        return JSON.stringify(response);
    } catch (err) {
        console.log("err", err);
        return JSON.stringify("Could not get resume data");
    }
};

export const getCompletion = async (text: string, type: string): Promise<string> => {
    try {
        const response = await API.post(apiName, "/ai/completion", {
            body: {
                completionType: type,
                message: text,
            },
        });
        return JSON.stringify(response);
    } catch (err) {
        console.log("err", err);
        return JSON.stringify("Could not retreive completion");
    }
};

export const compareVectorsWithTempVector = async (items: string[], tempText: string): Promise<ICompareVectorsResult|Error> => {
    try {
        const body = {
            comparisonItemIds: items,
            tempText: tempText,
        };
        const response = await API.post(apiName, "/ai/comparevectorswithtempvector", { body });
        return response;
    } catch (err) {
        console.log("err", err);
        return err as Error;
    }
};

export const pickBestMatchforItem = async (itemId: string, items: string[]): Promise<string> => {
    const result = await compareVectors(itemId, items);
    console.log("items :>> ", items);
    if (result instanceof Error) throw result;
    console.log("result :>> ", result);
    return result.max;
};

export const pickBestGroupforItem = async (itemId: string, groups: string[][]): Promise<number> => {
    const averageScores: number[] = [];
    console.log("groups :>> ", groups);
    groups.map(async (group: string[]) => {
        const result = await compareVectors(itemId, group);
        if (result instanceof Error) throw result;
        averageScores.push(result.average);
    });

    const indexOfMax = averageScores.reduce(
        (maxIndex, current, index, array) => (current > array[maxIndex] ? index : maxIndex),
        0,
    );

    return indexOfMax;
};